/**
 * Cart drawer offers - 10% code selection, auto-offer celebration, gift cleanup.
 *
 * This file is loaded from layout/theme.liquid on every page (whenever the cart type is
 * 'drawer'), NOT inline in the snippet. snippets/lz-offers.liquid only renders for a
 * non-empty cart, and drawer refreshes replace #CartDrawer.innerHTML, which never executes
 * <script> tags - so anything inline there would be dead for a visitor who arrived with an
 * empty cart and then added their first item. Keep this here.
 *
 * All handlers are document-level delegates so they survive every drawer re-render.
 *
 * OFFER MODEL (Oct 3 2026): Buy 1 Get 1 Free and Buy 2 Get 1 Free are AUTOMATIC discounts
 * (titles "B1G1Free" / "B2G1FREE") - Shopify applies them, there is nothing to tap. Only the
 * 10% code (GET10OFF) is still selected from the drawer via [data-lz-offer].
 *
 * CELEBRATION POPUP - two triggers, same card + confetti:
 *   1. Tapping the 10% row: if Shopify actually APPLIES the code (discount_codes[].applicable
 *      AND cart.total_discount > 0 in the /cart/update.js response) -> "Yay! 10% off applied /
 *      You saved Rs.X". No popup when it is not applicable or when it is cleared.
 *   2. AUTO OFFERS (Oct 3 2026, user agreed: fire only when an offer NEWLY unlocks, once per
 *      offer per visit): on every Dawn cartUpdate event (add to cart, quantity change) the
 *      cart is re-read; if B1G1Free / B2G1FREE now have a line-level discount (item.discounts
 *      in /cart.js, amount in paise) and that offer has not been celebrated yet this visit,
 *      one card is shown (both offers' names joined with " + " and the combined saving if
 *      they unlock together). "Visit" = sessionStorage key lzAutoOffersSeen. On page load the
 *      already-applied offers are marked seen silently, so returning to a cart never pops.
 * The amount is always read from the cart itself, so it can never show a number that is not
 * applied. Non-blocking (pointer-events: none), auto-removes after ~2.6s, no external
 * library. prefers-reduced-motion: the card still shows, the confetti does not.
 */
(function () {
  if (window.__lzOffersInit) return;
  window.__lzOffersInit = true;

  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var panelOpen = false;
  var busy = false;

  function post(url, payload) {
    return fetch(url, { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify(payload) }).then(function (r) {
      return r.json();
    });
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  /* Redraw the drawer from the server so Liquid re-evaluates every offer state. */
  function refreshDrawer() {
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var parser = new DOMParser();

        if (sections['cart-drawer']) {
          var newDoc = parser.parseFromString(sections['cart-drawer'], 'text/html');
          var fresh = newDoc.getElementById('CartDrawer');
          var live = document.getElementById('CartDrawer');
          if (fresh && live) live.innerHTML = fresh.innerHTML;
        }

        if (sections['cart-icon-bubble']) {
          var bubbleDoc = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
          var newBubble = bubbleDoc.querySelector('.shopify-section');
          var oldBubble = document.getElementById('cart-icon-bubble');
          if (newBubble && oldBubble) oldBubble.innerHTML = newBubble.innerHTML;
        }

        var drawerEl = document.querySelector('cart-drawer');
        if (drawerEl) {
          drawerEl.classList.remove('is-empty');
          drawerEl.classList.add('animate', 'active');
        }
        applyPanelState();
      });
  }

  function applyPanelState() {
    var panel = document.getElementById('LzOffersPanel');
    var toggle = document.getElementById('LzOffersToggle');
    if (!panel || !toggle) return;
    panel.hidden = !panelOpen;
    toggle.setAttribute('aria-expanded', panelOpen ? 'true' : 'false');
    if (panelOpen) {
      toggle.classList.add('lz-offers__toggle--open');
    } else {
      toggle.classList.remove('lz-offers__toggle--open');
    }
  }

  function setBusy(on) {
    busy = on;
    var panel = document.getElementById('LzOffersPanel');
    if (!panel) return;
    if (on) {
      panel.classList.add('lz-offers__busy');
    } else {
      panel.classList.remove('lz-offers__busy');
    }
  }

  /* A gift line is only free while FREEGIFT applies. Leaving it in the cart after
     switching to another offer would silently charge the customer for it. */
  function removeGiftLine() {
    return getCart().then(function (cart) {
      var gift = cart.items.filter(function (i) {
        return i.properties && i.properties._free_gift;
      })[0];
      if (!gift) return null;
      return post('/cart/change.js', { id: gift.key, quantity: 0 });
    });
  }

  /* /cart/update.js REPLACES the whole discount code set (and '' clears it).
     /discount/CODE does NOT - codes accumulate there and can never be removed,
     which makes switching offers impossible. Do not swap this back. */
  /* SPEED: ~1.0s from tap to popup. The gift check uses the update.js response itself (no
     extra request; the rare leftover gift line is removed right after, and its change.js
     response is what the popup reads), and the popup fires BEFORE the drawer redraw. */
  function selectOffer(code) {
    if (busy) return;
    setBusy(true);
    post('/cart/update.js', { discount: code, attributes: { lz_offer: code } })
      .then(function (cart) {
        var gift = code === 'FREEGIFT' || !cart || !cart.items ? null : cart.items.filter(function (i) {
          return i.properties && i.properties._free_gift;
        })[0];
        if (!gift) return cart;
        return post('/cart/change.js', { id: gift.key, quantity: 0 });
      })
      .then(function (cart) {
        maybeCelebrate(code, cart);
        return refreshDrawer();
      })
      .catch(function (e) { console.error('LZ offers: could not select offer', e); })
      .then(function () { setBusy(false); });
  }

  /* ---------- Celebration popup (see CELEBRATION note at top of file) ---------- */
  var OFFER_NAMES = { B2G1FREE: 'Buy 2 Get 1 Free', GET10OFF: '10% off', B1G1Free: 'Buy 1 Get 1 Free' };

  function formatRupees(paise) {
    var r = paise / 100;
    var whole = Math.round(r * 100) % 100 === 0;
    return '₹' + r.toLocaleString('en-IN', {
      minimumFractionDigits: whole ? 0 : 2,
      maximumFractionDigits: whole ? 0 : 2
    });
  }

  function maybeCelebrate(code, cart) {
    try {
      if (!code || !cart || !cart.discount_codes) return;
      var match = cart.discount_codes.filter(function (d) {
        return String(d.code).toUpperCase() === String(code).toUpperCase();
      })[0];
      if (!match || !match.applicable) return;
      if (!(cart.total_discount > 0)) return;
      celebrate(OFFER_NAMES[code] || code, formatRupees(cart.total_discount));
    } catch (e) {
      console.error('LZ offers: celebration failed', e);
    }
  }

  /* ---------- Auto-applied offers (Oct 3 2026) ---------- */
  var AUTO_OFFERS = { b1g1free: 'Buy 1 Get 1 Free', b2g1free: 'Buy 2 Get 1 Free', 'get 2 at 699 + nail glue free': 'Nails 2 for ₹699' };
  var SEEN_KEY = 'lzAutoOffersSeen';
  var autoSeen = null;
  var autoBusy = false;
  var autoPending = false;

  function loadSeen() {
    if (autoSeen) return autoSeen;
    autoSeen = {};
    try {
      var raw = window.sessionStorage.getItem(SEEN_KEY);
      if (raw) autoSeen = JSON.parse(raw) || {};
    } catch (e) {
      autoSeen = {};
    }
    return autoSeen;
  }

  function saveSeen() {
    try {
      window.sessionStorage.setItem(SEEN_KEY, JSON.stringify(autoSeen));
    } catch (e) { /* storage blocked - the popup may repeat, nothing else breaks */ }
  }

  /* { b1g1free: paise saved, ... } for every auto offer that currently has a line discount. */
  function appliedAutoOffers(cart) {
    var found = {};
    (cart.items || []).forEach(function (item) {
      (item.discounts || []).forEach(function (d) {
        var key = String(d.title || '').toLowerCase();
        if (AUTO_OFFERS[key] && d.amount > 0) found[key] = (found[key] || 0) + d.amount;
      });
    });
    return found;
  }

  function checkAutoOffers(silent) {
    if (autoBusy) {
      autoPending = true;
      return;
    }
    autoBusy = true;
    getCart()
      .then(function (cart) {
        var seen = loadSeen();
        var applied = appliedAutoOffers(cart);
        var fresh = Object.keys(applied).filter(function (k) { return !seen[k]; });
        if (!fresh.length) return;
        fresh.forEach(function (k) { seen[k] = true; });
        saveSeen();
        if (silent) return;
        var names = fresh.map(function (k) { return AUTO_OFFERS[k]; });
        var saved = fresh.reduce(function (sum, k) { return sum + applied[k]; }, 0);
        celebrate(names.join(' + '), formatRupees(saved));
      })
      .catch(function (e) { console.error('LZ offers: auto-offer check failed', e); })
      .then(function () {
        autoBusy = false;
        if (autoPending) {
          autoPending = false;
          checkAutoOffers(false);
        }
      });
  }

  function initAutoOffers() {
    checkAutoOffers(true);
    var hooked = false;
    function hook() {
      if (hooked) return;
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        hooked = true;
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () { checkAutoOffers(false); });
      }
    }
    hook();
    /* If Dawn's deferred pubsub.js has not run yet, try again once everything has loaded. */
    if (!hooked) window.addEventListener('load', hook);
  }

  function ensureCelebrateStyles() {
    if (document.getElementById('LzCelebrateStyles')) return;
    var style = document.createElement('style');
    style.id = 'LzCelebrateStyles';
    style.textContent =
      '.lz-celebrate-canvas{position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:2147483000;}' +
      '.lz-celebrate-card{position:fixed;left:50%;top:22%;z-index:2147483001;pointer-events:none;' +
      'transform:translate(-50%,0) scale(.6);opacity:0;min-width:220px;max-width:min(300px,86vw);' +
      'padding:1.6rem 2rem;border-radius:1.4rem;background:#fff;text-align:center;' +
      'box-shadow:0 12px 40px rgba(224,67,92,.35);border:2px solid #ff7a3c;' +
      'transition:transform .35s cubic-bezier(.2,1.4,.4,1),opacity .25s ease;font-family:inherit;}' +
      '.lz-celebrate-card.is-in{transform:translate(-50%,0) scale(1);opacity:1;}' +
      '.lz-celebrate-card.is-out{transform:translate(-50%,-12px) scale(.95);opacity:0;transition:transform .3s ease,opacity .3s ease;}' +
      '.lz-celebrate-emoji{display:block;font-size:3.2rem;line-height:1;margin-bottom:.4rem;}' +
      '.lz-celebrate-title{display:block;font-size:1.7rem;font-weight:800;line-height:1.25;' +
      'background:linear-gradient(135deg,#ff3b6b,#ff7a3c);-webkit-background-clip:text;background-clip:text;color:transparent;}' +
      '.lz-celebrate-sub{display:block;margin-top:.35rem;font-size:1.45rem;font-weight:700;color:#1a9c53;}';
    document.head.appendChild(style);
  }

  function celebrate(offerName, savedText) {
    ensureCelebrateStyles();

    var old = document.querySelectorAll('.lz-celebrate-card, .lz-celebrate-canvas');
    for (var i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);

    var card = document.createElement('div');
    card.className = 'lz-celebrate-card';
    card.setAttribute('role', 'status');
    card.setAttribute('aria-live', 'polite');
    var emoji = document.createElement('span');
    emoji.className = 'lz-celebrate-emoji';
    emoji.textContent = '🎉';
    var title = document.createElement('span');
    title.className = 'lz-celebrate-title';
    title.textContent = 'Yay! ' + offerName + ' applied';
    var sub = document.createElement('span');
    sub.className = 'lz-celebrate-sub';
    sub.textContent = 'You saved ' + savedText;
    card.appendChild(emoji);
    card.appendChild(title);
    card.appendChild(sub);
    document.body.appendChild(card);
    requestAnimationFrame(function () { card.classList.add('is-in'); });

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduceMotion) runConfetti(2400);

    setTimeout(function () {
      card.classList.remove('is-in');
      card.classList.add('is-out');
      setTimeout(function () { if (card.parentNode) card.parentNode.removeChild(card); }, 350);
    }, 2600);
  }

  function runConfetti(durationMs) {
    var canvas = document.createElement('canvas');
    canvas.className = 'lz-celebrate-canvas';
    document.body.appendChild(canvas);
    var ctx = canvas.getContext('2d');
    if (!ctx) { canvas.parentNode.removeChild(canvas); return; }
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = window.innerWidth;
    var h = window.innerHeight;
    canvas.width = w * dpr;
    canvas.height = h * dpr;
    ctx.scale(dpr, dpr);

    var colors = ['#ff3b6b', '#ff7a3c', '#ffd166', '#e0435c', '#2ecc71', '#f6c9cf'];
    var pieces = [];
    var count = w < 500 ? 110 : 160;
    for (var i = 0; i < count; i++) {
      var fromLeft = i % 2 === 0;
      pieces.push({
        x: fromLeft ? w * 0.15 : w * 0.85,
        y: h * 0.35,
        vx: (fromLeft ? 1 : -1) * (2 + Math.random() * 6) + (Math.random() - 0.5) * 3,
        vy: -(7 + Math.random() * 8),
        size: 5 + Math.random() * 6,
        color: colors[i % colors.length],
        rot: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.3,
        shape: i % 3,
        maxFall: 2.2 + Math.random() * 2.2,
        phase: Math.random() * Math.PI * 2
      });
    }

    // Motion is scaled by elapsed time (k = frames at 60fps) so the burst
    // looks the same on 60Hz and 120Hz screens; maxFall makes pieces drift
    // down like paper instead of dropping off-screen in under a second.
    var start = null;
    var last = null;
    function frame(ts) {
      if (start === null) { start = ts; last = ts; }
      var t = ts - start;
      var k = Math.min((ts - last) / 16.667, 3);
      last = ts;
      ctx.clearRect(0, 0, w, h);
      var fade = t > durationMs - 500 ? Math.max(0, (durationMs - t) / 500) : 1;
      ctx.globalAlpha = fade;
      for (var j = 0; j < pieces.length; j++) {
        var p = pieces[j];
        p.vy = Math.min(p.vy + 0.28 * k, p.maxFall);
        p.vx *= Math.pow(0.97, k);
        p.x += (p.vx + Math.sin(t / 220 + p.phase) * 0.8) * k;
        p.y += p.vy * k;
        p.rot += p.vr * k;
        ctx.save();
        ctx.translate(p.x, p.y);
        ctx.rotate(p.rot);
        ctx.fillStyle = p.color;
        if (p.shape === 0) {
          ctx.fillRect(-p.size / 2, -p.size / 4, p.size, p.size / 2);
        } else if (p.shape === 1) {
          ctx.beginPath();
          ctx.arc(0, 0, p.size / 2.6, 0, Math.PI * 2);
          ctx.fill();
        } else {
          ctx.fillRect(-p.size / 3, -p.size / 3, p.size / 1.5, p.size / 1.5);
        }
        ctx.restore();
      }
      if (t < durationMs) {
        requestAnimationFrame(frame);
      } else if (canvas.parentNode) {
        canvas.parentNode.removeChild(canvas);
      }
    }
    requestAnimationFrame(frame);
  }

  function clearOffer() {
    if (busy) return;
    setBusy(true);
    removeGiftLine()
      .then(function () {
        return post('/cart/update.js', { discount: '', attributes: { lz_offer: '' } });
      })
      .then(refreshDrawer)
      .catch(function (e) { console.error('LZ offers: could not clear offer', e); })
      .then(function () { setBusy(false); });
  }

  function removeGiftByKey(key) {
    if (busy) return;
    setBusy(true);
    post('/cart/change.js', { id: key, quantity: 0 })
      .then(refreshDrawer)
      .catch(function (e) { console.error('LZ offers: could not remove gift', e); })
      .then(function () { setBusy(false); });
  }

  function addGift(button) {
    if (busy) return;
    setBusy(true);
    button.disabled = true;
    post('/cart/add.js', {
      items: [{ id: button.getAttribute('data-free-gift-variant-id'), quantity: 1, properties: { _free_gift: 'true' } }]
    })
      .then(function (data) {
        if (data && data.status) throw new Error(data.description || 'Could not add gift');
        return refreshDrawer();
      })
      .catch(function (error) {
        console.error('Free gift: could not add product to cart', error);
        button.disabled = false;
        window.alert('Sorry, that gift could not be added. Please try another one.');
      })
      .then(function () { setBusy(false); });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var toggle = target.closest('#LzOffersToggle');
    if (toggle) {
      event.preventDefault();
      panelOpen = !panelOpen;
      applyPanelState();
      return;
    }

    var choice = target.closest('[data-lz-offer]');
    if (choice) {
      event.preventDefault();
      if (choice.disabled) return;
      var code = choice.getAttribute('data-lz-offer');
      /* Tapping the selected offer again clears it. */
      if (choice.getAttribute('aria-pressed') === 'true') {
        clearOffer();
      } else {
        selectOffer(code);
      }
      return;
    }

    if (target.closest('#LzOffersClear')) {
      event.preventDefault();
      clearOffer();
      return;
    }

    var removeBtn = target.closest('[data-lz-remove-gift]');
    if (removeBtn) {
      event.preventDefault();
      removeGiftByKey(removeBtn.getAttribute('data-lz-remove-gift'));
      return;
    }

    var giftBtn = target.closest('.free-gift-picker__item');
    if (giftBtn && !giftBtn.disabled && giftBtn.getAttribute('data-free-gift-variant-id')) {
      event.preventDefault();
      addGift(giftBtn);
    }
  });

  /* Dawn's cart-drawer.js also re-renders the drawer on quantity changes, which would
     otherwise reset the open/closed state. Watch childList only; state is applied via
     attributes, so this cannot feed itself. */
  function watch() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || drawer.__lzWatched) return;
    drawer.__lzWatched = true;
    new MutationObserver(applyPanelState).observe(drawer, { childList: true, subtree: true });
  }

  /* DOMContentLoaded (or already past it): by then every deferred script has run, so Dawn's
     subscribe() / PUB_SUB_EVENTS exist for initAutoOffers. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { watch(); applyPanelState(); initAutoOffers(); });
  } else {
    watch();
    applyPanelState();
    initAutoOffers();
  }
})();
